<script>
import api from '@/helpers/api-rest/api.js';

export default {
  props: {
    showConsumerModal: Boolean,
    consumer: {type: Object, default: () => {
        return {
            name: '',
            address: '',
            postal_code: '',
            cnae: '',
            latitude: '',
            longitude: '',
            selectedCompanyType: '',
            selectCommunities: '',
            selectProvinces: '',
            selectMunicipalities: '',
            autonomous_community_id: '',
            province_id: ''
        }
    }} 
  },
  data() {
    return {
      selectOptionsCompanyType: [],
      selectedCommunities: [],
      selectedProvinces: [],
      selectedMunicipalities: [],
    };
  },
  computed: {
    modalTitle() {
      return this.consumer?.id ? 'Editar Consumidora' : 'Añadir Consumidora';
    },
    submitButtonText() {
        return this.consumer?.id ? 'Guardar' : 'Añadir Consumidora';
    }
  },
  created() {
    //console.log(this.consumer.id);
    this.loadSelectOptions();
    this.loadSelectCommunities();
    this.loadSelectProvinces(this.consumer.autonomous_community_id);
    this.loadSelectMunicipality(this.consumer.province_id);
   // this.loadSelectProvinces();
  },
  methods: {
    onCommunityChange() {
      const selectedCommunityId = this.consumer.autonomous_community_id;
      this.loadSelectProvinces(selectedCommunityId);
    },
    onProvinceChange() {
      const selectedProvinceId = this.consumer.province_id;
      this.loadSelectMunicipality(selectedProvinceId);
    },
    loadSelectOptions() {
      const apiEndpoint = `/api/v1/company-types`;
      api.get({url:apiEndpoint})
        .then(response => {
          this.selectOptionsCompanyType = response.data;
        })
        .catch(error => {
          console.error("Error al cargar los tipos de compañias:", error);
        });
    },
    loadSelectCommunities() {
      const apiEndpoint = `/api/v1/autonomous_communities`;
      api.get({url:apiEndpoint, params:{
        'status': 1
      }})
        .then(response => {
          this.selectedCommunities = response.data;
        })
        .catch(error => {
          console.error("Error al cargar las comunidades:", error);
        });
    },
    loadSelectProvinces(selectedCommunityId) {
      const apiEndpoint = `/api/v1/provinces`;
      api.get({url:apiEndpoint, params:{
        'status': 1,
        'autonomous_community_id': selectedCommunityId
      }})
        .then(response => {
          this.selectedProvinces = response.data;
        })
        .catch(error => {
          console.error("Error al cargar las provincias:", error);
        });
    },
    loadSelectMunicipality(selectedProvinceId) {
      const apiEndpoint = `/api/v1/municipalities`;
      api.get({url:apiEndpoint, params:{
        'status': 1,
        'province_id': selectedProvinceId
      }})
        .then(response => {
          //console.log(response);
          this.selectedMunicipalities = response.data;
        })
        .catch(error => {
          console.error("Error al cargar las localidades:", error);
        });
    },
    createConsumer() {
      //const apiHost = process.env.VUE_APP_API_HOST;
      const apiEndpoint = `/api/v1/consumer-companies`; 
      api.post({url:apiEndpoint, data:this.consumer})
      //axios.post(apiEndpoint, this.consumer)
        .then(response => {
          const newConsumer = response.data;
          this.$emit('success', newConsumer);
          this.$bvModal.hide("ModalConsumer");
        })
        .catch(error => {
          console.error("Error al crear el consumidor:", error);
        });
    },

    updateConsumer() {
        const apiEndpoint = `/api/v1/consumer-companies`;
        api.put({url:apiEndpoint, data:this.consumer, id:this.consumer.id})
        .then(response => {
            const updatedConsumer = response.data;
            this.$emit('success', updatedConsumer);
            this.$bvModal.hide("ModalConsumer");
        })
        .catch(error => {
            console.error("Error editing consumer:", error);
        });
    },

    submitForm() {        
        if(this.consumer?.id){
            return this.updateConsumer();
        }

        return this.createConsumer();
    },
    cancelForm() {
        this.$bvModal.hide("ModalConsumer");
        this.$emit('close-modal');
    }
  }
};
</script>


<template>
  
  <b-modal id="ModalConsumer" :title="modalTitle" :size="'xl'">  
    <template #default="{  }">
      <form @submit.prevent="submitForm">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-xs-12 mb-2">
            <div class="card">
              <div class="card-header text-white bg-primary">Información general</div>
              <div class="card-body">
                <div class="row">
                  <div class="form-group col-md-4 col-xs-12">
                      <label for="name">Nombre:</label>
                      <input v-model="consumer.name" type="text" class="form-control" id="name" required>
                  </div>
                  <div class="form-group col-md-4 col-xs-12">
                      <label for="address">Dirección:</label>
                      <input v-model="consumer.address" type="text" class="form-control" id="address" required>
                  </div>
                  <div class="form-group col-md-4 col-xs-12">
                      <label for="postal_code">Código postal:</label>
                      <input v-model="consumer.postal_code" type="text" class="form-control" id="postal_code" required>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-4 col-xs-12">
                      <label for="cnae">CNAE:</label>
                      <input v-model="consumer.cnae" type="text" class="form-control" id="cnae" required>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-xs-12 mb-2">
            <div class="card">
              <div class="card-header text-white bg-primary">Localización</div>
              <div class="card-body">
                <div class="row">
                  <div class="form-group col-md-4 col-xs-12">
                    <label for="selectCommunities">Selecciona una comunidad:</label>
                    <select v-model="consumer.autonomous_community_id" @change="onCommunityChange" class="form-control" id="selectCommunities">
                      <option v-for="option in selectedCommunities" :value="option.id" :key="option.id">{{ option.name }}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-4 col-xs-12">
                    <label for="selectProvinces">Selecciona una provincia:</label>
                    <select v-model="consumer.province_id" @change="onProvinceChange" class="form-control" id="selectProvinces" :disabled="!consumer.autonomous_community_id">
                      <option v-for="option in selectedProvinces" :value="option.id" :key="option.id">{{ option.name }}</option>
                    </select>
                  </div>
                  <div class="form-group col-md-4 col-xs-12">
                    <label for="selectMunicipalities">Selecciona una localidad:</label>
                    <select v-model="consumer.municipality_id" class="form-control" id="selectMunicipalities" :disabled="!consumer.province_id">
                      <option v-for="option in selectedMunicipalities" :value="option.id" :key="option.id">{{ option.name }}</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-4 col-xs-12">
                      <label for="latitude">Latitud:</label>
                      <input v-model="consumer.latitude" type="text" class="form-control" id="latitude" required>
                  </div>
                  <div class="form-group col-md-4 col-xs-12">
                      <label for="longitude">Longitud:</label>
                      <input v-model="consumer.longitude" type="text" class="form-control" id="longitude" required>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <!-- <form @submit.prevent="submitForm">
          <div class="form-group">
              <label for="name">Nombre:</label>
              <input v-model="consumer.name" type="text" class="form-control" id="name" required>
          </div>
          <div class="form-group">
              <label for="address">Dirección:</label>
              <input v-model="consumer.address" type="text" class="form-control" id="address" required>
          </div>
          <div class="form-group">
              <label for="postal_code">Código postal:</label>
              <input v-model="consumer.postal_code" type="text" class="form-control" id="postal_code" required>
          </div>
          <div class="form-group">
              <label for="cnae">CNAE:</label>
              <input v-model="consumer.cnae" type="text" class="form-control" id="cnae" required>
          </div>
          <div class="form-group">
              <label for="latitude">Latitud:</label>
              <input v-model="consumer.latitude" type="text" class="form-control" id="latitude" required>
          </div>
          <div class="form-group">
              <label for="longitude">Longitud:</label>
              <input v-model="consumer.longitude" type="text" class="form-control" id="longitude" required>
          </div>
          <div class="form-group">
            <label for="selectedCompanyType">Selecciona una opción:</label>
            <select v-model="consumer.company_type_id" class="form-control" id="selectedCompanyType">
              <option v-for="option in selectOptionsCompanyType" :value="option.id" :key="option.id">{{ option.name }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="selectCommunities">Selecciona una comunidad:</label>
            <select v-model="consumer.autonomous_community_id" @change="onCommunityChange" class="form-control" id="selectCommunities">
              <option v-for="option in selectedCommunities" :value="option.id" :key="option.id">{{ option.name }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="selectProvinces">Selecciona una provincia:</label>
            <select v-model="consumer.province_id" @change="onProvinceChange" class="form-control" id="selectProvinces" :disabled="isDisabledProvince">
              <option v-for="option in selectedProvinces" :value="option.id" :key="option.id">{{ option.name }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="selectMunicipalities">Selecciona una localidad:</label>
            <select v-model="consumer.municipality_id" class="form-control" id="selectMunicipalities" :disabled="isDisabledMunicipality">
              <option v-for="option in selectedMunicipalities" :value="option.id" :key="option.id">{{ option.name }}</option>
            </select>
          </div>
      </form> -->
    </template>

    <template #modal-footer="{  }">
      <b-button variant="primary" @click="submitForm()">{{ submitButtonText }}</b-button>
      <b-button @click="cancelForm()">Cancelar</b-button>
    </template>
  </b-modal>
</template>